var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssistTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E7F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.4999H7C6.86739 17.4999 6.74021 17.4472 6.64645 17.3535C6.55268 17.2597 6.5 17.1325 6.5 16.9999V14.207C6.5 14.1414 6.51293 14.0764 6.53806 14.0157C6.56319 13.955 6.60002 13.8999 6.64645 13.8535L14.1464 6.35348C14.2402 6.25971 14.3674 6.20703 14.5 6.20703C14.6326 6.20703 14.7598 6.25971 14.8536 6.35348L17.6464 9.14637C17.7402 9.24014 17.7929 9.36732 17.7929 9.49992C17.7929 9.63253 17.7402 9.75971 17.6464 9.85348L10 17.4999Z",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8L16 11.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 17.4999H10.0004L6.53223 14.0317",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistTextIcon);
export default __webpack_public_path__ + "static/media/assist-text-icon.a6a4bb5f8f561af702e3d472e5065247.svg";
export { ForwardRef as ReactComponent };